import { jsx as $ } from "react/jsx-runtime";
import { c as q } from "../../../index-Cu0xwYjD.js";
import '../../../assets/Margin.css';const w = "_top_1jm93_3", C = "_bottom_1jm93_7", D = "_left_1jm93_11", E = "_right_1jm93_15", F = "_horizontal_1jm93_19", G = "_vertical_1jm93_24", I = "_all_1jm93_29", J = "_inline_1jm93_33", m = {
  top: w,
  bottom: C,
  left: D,
  right: E,
  horizontal: F,
  vertical: G,
  all: I,
  inline: J
}, Q = ({
  top: i,
  bottom: r,
  left: o,
  right: n,
  horizontal: e,
  vertical: g,
  all: s,
  inline: c,
  children: _
}) => {
  const t = (a) => Array.isArray(a) ? a : [a], l = (a) => a ? `var(--el-core-space-${a})` : "", [d, h, u] = t(i), [p, f, j] = t(r), [z, b, v] = t(o), [A, y, B] = t(n), [H, L, R] = t(e), [T, V, x] = t(g), [N, k, M] = t(s);
  return /* @__PURE__ */ $(
    "div",
    {
      style: {
        "--small-margin-top": l(d),
        "--medium-margin-top": l(h),
        "--large-margin-top": l(u),
        "--small-margin-bottom": l(p),
        "--medium-margin-bottom": l(f),
        "--large-margin-bottom": l(j),
        "--small-margin-left": l(z),
        "--medium-margin-left": l(b),
        "--large-margin-left": l(v),
        "--small-margin-right": l(A),
        "--medium-margin-right": l(y),
        "--large-margin-right": l(B),
        "--small-margin-horizontal": l(H),
        "--medium-margin-horizontal": l(L),
        "--large-margin-horizontal": l(R),
        "--small-margin-vertical": l(T),
        "--medium-margin-vertical": l(V),
        "--large-margin-vertical": l(x),
        "--small-margin-all": l(N),
        "--medium-margin-all": l(k),
        "--large-margin-all": l(M)
      },
      className: q({
        [m.top]: i,
        [m.bottom]: r,
        [m.right]: n,
        [m.left]: o,
        [m.horizontal]: e,
        [m.vertical]: g,
        [m.all]: s,
        [m.inline]: c
      }),
      children: _ ?? null
    }
  );
};
export {
  Q as Margin
};
